/*** masterStyles.js ***/
/* Project: Pump Panel Simulator
   Descript: Training tool to assist in learing 
   Created: Kendra Wainscott  2022

   Color Palette & Font Families for entire APP

   https://coolors.co/ffebe1-77705c-e1b34f-fffdfb-c61403-3e3f3f
*/
const colorPaletteMaster = {
  black: "rgba(0,0,0, 1)",
  blackLight: "rgba(40, 40, 40, 1)",
  grayDark: "rgba(62, 63, 63, 1)",
  grayDarkLight: "rgba(72, 73, 73, 1)",
  grayGreen: "rgba(119, 112, 92, 1)",
  grayHighlight: "rgba(130, 130, 130, 1)",
  grayLight: "rgba(210, 211, 213, 1)",
  green: "rgba(50, 164, 49, 1)",
  orangeWarning: "rgba(255, 103, 0, 1)",
  pinkLight: "rgba(255, 235, 225, 1)",
  pinkLightFade: "rgba(255, 235, 225, .3)",
  red: "rgba(198, 20, 3, 1)",
  redMid: "rgb(116, 25, 25)",
  redDark: "rgb(68, 14, 14)",
  white: "rgba(255, 253, 251, 1)",
  whiteAbsolute: "rgb(255,255,255)",
  yellow: "rgba(225, 179, 79, 1)",
};
const fontListMaster = {
  handWrittenTitle: "'Patrick Hand SC', san-serif, monospace",
  handWritten: "'Architects Daughter', san-serif, monospace",
};

export const masterStyles = {
  colorPalette: colorPaletteMaster,
  fontList: fontListMaster,
};
